import {
  Button,
  Box,
  Container,
  Heading,
  Icon,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { getNewsDetailPath } from "../../config/routes";
import { NewsCard } from "../news/NewsCard";
import { news } from "../../services/api";
import { getNewsSeoPathSegment } from "../../utils/news";

const MotionBox = motion(Box);

export const BlogSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const navigate = useNavigate();

  const { data } = useQuery({
    queryKey: ["landing-news", "latest"],
    queryFn: () => news.getPublic({ pageSize: 4, isFeatured: true }),
  });

  const latestItems = data?.news || [];

  return (
    <Box id="blog" py={20} ref={ref}>
      <Container maxW="container.xl">
        <VStack spacing={12}>
          {/* Section Header */}
          <VStack spacing={4} textAlign="center">
            <Heading as="h2" fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}>
              اطلاع‌رسانی و تحلیل‌های منتخب
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color="gray.500"
              maxW="600px"
            >
              مجموعه‌ای از خبرها، گزارش‌ها و تحلیل‌های منتخب را مرور کنید و از
              تازه‌ترین محتوای منتشرشده باخبر بمانید
            </Text>
          </VStack>

          {/* Blog Posts Grid */}
          <SimpleGrid
            columns={{ base: 1, md: 2, xl: 4 }}
            spacing={{ base: 6, md: 8 }}
            w="100%"
          >
            {latestItems.map((post, index) => {
              return (
                <MotionBox
                  key={post._id}
                  initial={{ opacity: 0, y: 30 }}
                  animate={
                    isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }
                  }
                  transition={{ duration: 0.5, delay: index * 0.15 }}
                  whileHover={{ y: -8 }}
                >
                  <NewsCard
                    item={post}
                    onClick={() =>
                      navigate(
                        getNewsDetailPath(
                          post.category,
                          post.slug,
                          getNewsSeoPathSegment(post),
                        ),
                      )
                    }
                  />
                </MotionBox>
              );
            })}
          </SimpleGrid>

          {/* CTA Button */}
          <Button
            size="lg"
            colorScheme="brand"
            variant="secondary"
            _hover={{
              transform: "translateY(-2px)",
              shadow: "md",
            }}
            transition="all 0.3s"
            rightIcon={<Icon verticalAlign="middle" as={FiArrowLeft as any} />}
            onClick={() => navigate("/news")}
          >
            مشاهده آرشیو محتواها
          </Button>
        </VStack>
      </Container>
    </Box>
  );
};
